module.exports = __webpack_public_path__ + "img/0Q3B1891_FoamcoreMatted.9a6e34c1.jpg";